<template>
  <section :class="background" class="white--text">
    <v-container class="text-center">
      <div class="text">
        "{{ text }}"
      </div>
      <div
        v-if="subtext"
        class="subtext text--lighten-3"
        :class="`${color}--text`"
      >
        {{ subtext }}
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  components: {
  },
  props: {
    color: {
      type: String,
      required: false,
      default: 'orange',
    },
    darken: {
      type: String,
      required: false,
      default: 'darken-2',
    },
    text: {
      type: String,
      required: true,
    },
    subtext: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    background() {
      return `${this.color} ${this.darken}`
    },
  },
  created() {
  },
  methods: {

  },
}
</script>

<style lang='scss' scoped>
  .text {
    font-size: 28px;
  }
  .subtext {
    font-size: 16px;
  }
</style>
